import { SET_LOCATIONS } from '../constants/action-types';
export const setLocations = ({ locations }) => ({
    type: SET_LOCATIONS,
    payload: {
        locations,
    },
});
